import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberOnlyDirective } from './Directives/number.directive';
import { InputMaxLengthDirective } from './Directives/InputMaxLength.directive';
import { SafePipe } from './Pipe/Safe.pipe';
import { NoContentComponent } from './Component/NoContent/NoContent.component';
import { RouterModule } from '@angular/router';
import {MatMenuModule} from '@angular/material/menu';
//import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FilterPipe } from './Pipe/filter.pipe';
import { SortByPipe } from './Pipe/SortBy.pipe';
import { ChatcontFilterPipe } from './Pipe/ChatcontFilter.pipe';
import { FBorderByPipe } from './Pipe/FBorderBy.pipe';
import { DateformatPipe } from './Pipe/dateformat.pipe';
import { SafeHtmlPipe } from './Pipe/SafeHtml.pipe';
import { ScrollerDirective } from './Directives/Scroller.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatDialogModule } from '@angular/material/dialog';
import { FiltercountPipe } from './Pipe/filtercount.pipe';
import { NetworkComponent } from './Component/Network/Network.component';
//import { NotificationComponent } from './Component/Notification/Notification.component';
import { LoaderComponent } from './Component/Loader/Loader.component';
import { ToastComponent } from './Component/Toast/Toast.component';
import { ProfileMenuComponent } from './Component/ProfileMenu/ProfileMenu.component';
import { PopupComponent } from './Component/Popup/Popup.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { LocationLoaderComponent } from './Component/LocationLoader/LocationLoader.component';
import { ContactPopupComponent } from './Component/ContactPopup/ContactPopup.component';
import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDateFormats, NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentAdapter } from '@angular-material-components/moment-adapter';
import { PlanNotificationComponent } from './Component/PlanNotification/PlanNotification.component';
import { CCalendarComponent } from './Component/CCalendar/CCalendar.component';
import { LocationInfoComponent } from './Component/LocationInfo/LocationInfo.component';
import { AppNotificationComponent } from './Component/AppNotification/AppNotification.component';
import { FooterComponent } from './Component/Footer/Footer.component';
import { CustomerTemplateComponent } from './Component/CustomerTemplate/CustomerTemplate.component';
import { CTVerifyComponent } from './Component/CustomerTemplate/CTVerify/CTVerify.component';
import { CTPlanMoveComponent } from './Component/CustomerTemplate/CTPlanMove/CTPlanMove.component';
import { CTPlanRejectionComponent } from './Component/CustomerTemplate/CTPlanRejection/CTPlanRejection.component';
import { CTPlanReasonComponent } from './Component/CustomerTemplate/CTPlanReason/CTPlanReason.component';
import { GoogleMapCustomerComponent } from './Component/GoogleMapCustomer/GoogleMapCustomer.component';
import { CTPlanCalendarComponent } from './Component/CustomerTemplate/CTPlanCalendar/CTPlanCalendar.component';
import { CDPlanAppointmentComponent } from './Component/CustomerTemplate/CDPlanAppointment/CDPlanAppointment.component';
import { CTDigipinMapComponent } from './Component/CustomerTemplate/CTDigipinMap/CTDigipinMap.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Select2Module } from 'ng-select2-component';
import { NgOtpInputModule } from 'ng-otp-input';
import { ClickOutsideDirective } from './Directives/clickOutside.directive';
import { CTripCalendarComponent } from './Component/CTripCalendar/CTripCalendar.component';
import { AppCurrencyFormatterDirective } from './Directives/appCurrencyFormatter.directive';
import { NgxCaptureModule } from 'ngx-capture';
import { TwoDecimalDirective } from './Directives/TwoDecimal.directive';
export const MY_FORMATS = {
  parse: { dateInput: 'LL' },display: { dateInput: 'DD-MM-YYYY',monthYearLabel: 'YYYY',dateA11yLabel: 'LL',monthYearA11yLabel: 'YYYY' }
};

const MY_NGX_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: "l, LTS"
  },
  display: {
    dateInput: "DD.MM.yyyy HH:mm",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA], //map concept
  imports: [
    NgxCaptureModule , CommonModule,FormsModule,RouterModule,MatMenuModule,
    MatDatepickerModule,MatNativeDateModule,MatAutocompleteModule, FormsModule,ReactiveFormsModule,
    NgxMatDatetimePickerModule,Select2Module,NgOtpInputModule,NgMultiSelectDropDownModule.forRoot(),
  ],
  declarations:[
    SafePipe,NetworkComponent,
    //NotificationComponent,
    NumberOnlyDirective,InputMaxLengthDirective,
    FilterPipe,SortByPipe,ChatcontFilterPipe,FBorderByPipe,DateformatPipe,SafeHtmlPipe,
    ScrollerDirective,NumberOnlyDirective,InputMaxLengthDirective,AppCurrencyFormatterDirective,
    FiltercountPipe
    , LoaderComponent,ToastComponent,ProfileMenuComponent,NoContentComponent,PopupComponent,
    LocationLoaderComponent,ContactPopupComponent, PlanNotificationComponent,CCalendarComponent,LocationInfoComponent,
    AppNotificationComponent,FooterComponent, CustomerTemplateComponent,CTVerifyComponent,CTPlanMoveComponent,
    CTPlanReasonComponent,CTPlanRejectionComponent, GoogleMapCustomerComponent,CTPlanCalendarComponent,CTPlanCalendarComponent,
    CDPlanAppointmentComponent,CTDigipinMapComponent,ClickOutsideDirective,CTripCalendarComponent,TwoDecimalDirective,TwoDecimalDirective
  ],
  providers:[
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    {
      provide: NgxMatDateAdapter,
      useClass: NgxMatMomentAdapter, //Moment adapter
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
  { provide: NGX_MAT_DATE_FORMATS, useValue: MY_NGX_DATE_FORMATS }

  ],
  // entryComponents: [
  //   ConfirmPPComponent
  // ],
  exports:[
    NgxCaptureModule,
    CommonModule, FormsModule,
    NumberOnlyDirective,InputMaxLengthDirective,AppCurrencyFormatterDirective,
    NetworkComponent,
    //NotificationComponent,
  SafePipe,RouterModule,MatMenuModule
  ,FilterPipe,SortByPipe,FBorderByPipe,DateformatPipe,SafeHtmlPipe,
  ScrollerDirective,
  MatDatepickerModule,MatNativeDateModule,FiltercountPipe
 ,LoaderComponent,ToastComponent,ProfileMenuComponent
,NoContentComponent,
FiltercountPipe,
  MatAutocompleteModule,FormsModule,ReactiveFormsModule,LocationLoaderComponent,
  ContactPopupComponent, NgxMatDatetimePickerModule, PlanNotificationComponent,CCalendarComponent,
  LocationInfoComponent,AppNotificationComponent,FooterComponent, CustomerTemplateComponent,PopupComponent,GoogleMapCustomerComponent,
  NoContentComponent,CTPlanCalendarComponent,Select2Module,NgOtpInputModule,ClickOutsideDirective,CDPlanAppointmentComponent,CTDigipinMapComponent,
  CTripCalendarComponent,TwoDecimalDirective
  ]
})
export class SharedModule { }
